import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { AuthService } from './auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '@components/snackbar/snackbar.component';

export type DocumentType = 'DRIVER_LICENSE' | 'INSURANCE_CARD' | 'PHOTO_ID' | 'MEDICAL_RECORDS' | 'OTHER';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    modelMessage: any;
    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private _snackBar: MatSnackBar,
    ) { }

    apiCall(method: any, url: any, payload?: any, params?: any, headers?: HttpHeaders, responseType: any = null): Observable<any> {
        let apiData;
        const HttpClient: any = this.http

        const deviceToken = this.authService.getDeviceToken();
        if (deviceToken) {
            if (!headers) {
                headers = new HttpHeaders();
            }
            headers = headers.set('x-device-token', deviceToken);
        }

        if (method === 'get') {
            apiData = HttpClient[method](url, { headers, params, responseType });
        } else if (method === 'put' || method === 'post' || method === 'patch') {
            apiData = HttpClient[method](url, payload, { headers, ...params, responseType });
        } else {
            apiData = HttpClient[method](url, { headers, ...params, responseType });
        }
        return apiData.pipe(
            map((body: any) => {
                return body;
            })
        );
    }

    showMessageModal(message: any, success: boolean = true) {
        this.modelMessage = message

        this._snackBar.openFromComponent(SnackbarComponent, {
            duration: 2500,
            verticalPosition: 'top',
            horizontalPosition: 'center',
            panelClass: success ? 'success-snackbar' : 'error-snackbar'
        });
    }

    getProfile() {
        return this.apiCall('get', 'ownly/profile').pipe(
            tap(response => {
                this.authService.userProfile.next({
                    patient: response.userId,
                    profile: response.email,
                    accessToken: response.token ?? this.authService.getToken()
                });
            })
        )
    }
}
